/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import { withTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';

import { Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import TextField from '@material-ui/core/TextField';
import { useMutation } from '@apollo/client';
import { CREATE_USERS_ACCOUNT } from '../../queries';
import { useThemeData } from '../../context/ThemeDataContext';
import { yupResolver } from '@hookform/resolvers/yup';
import { RegistrationSchema } from '../../validations/UserValidation';
import { formContent } from '../../statics/RegisterFormData';
import GeneralButton from "../Buttons";
import GeneralText from "../Fonts";

function RegistrateFormComponent(props) {
  const { site_id, primary_color_2 } = useThemeData().themeData.site;

  const { control, handleSubmit, formState: { errors } } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
    resolver: yupResolver(RegistrationSchema)
  });

  const login_name = localStorage.getItem("login_name");

  const Registrated = (data) => {
    localStorage.setItem('login_email', data.registerAccount.email);
    props.setMessages(prevState => ({ ...prevState, message: true }));
  }

  const [registerAccount,
    { loading: loadingRegisterAccount, error: errorRegisterAccount }]
      = useMutation(CREATE_USERS_ACCOUNT, {
        onCompleted: (data) => Registrated(data),
        onError: (error) => {
          console.error(error);
        }
      }
  );

  const onSubmit = (e) => {
    registerAccount({
      variables: {
        site_id: site_id,
        login_name: login_name,
        email: e.email,
        password: e.password,
        roles: 'user'
      }
    });
  }

  if (loadingRegisterAccount) return <p>{props.t('Loading...')}</p>

  return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container direction="row">
          <Grid item className="col-lg-12 col-md-12 col-12">
            <Grid container direction="row" style={{ margin: `4px` }}>
              <GeneralText
                  style={{ color: primary_color_2 }}
                  variant="h6"
                  gutterBottom={true}
              >
                {props.t('register:Register')}
              </GeneralText>
            </Grid>
          </Grid>
        </Grid>
        {errorRegisterAccount &&
            <Alert severity="error">
              {props.t('register:Duplicate email')}
            </Alert>
        }
        {formContent.inputs.map((input, key) => (
            <Grid container direction="row" key={key}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Controller name={input.name} control={control} render={({ field }) =>
                    <TextField
                        {...field}
                        id={input.id}
                        type={input.type}
                        margin="normal"
                        label={props.t(`register:${input.label}`)}
                        autoComplete={input.autocomplete}
                        className="mb-2"
                        variant="outlined"
                        autoFocus
                        fullWidth
                    />
                } />

                {!errorRegisterAccount && errors[input.name] &&
                    <Alert severity="error">
                      {props.t(`register:${errors[input.name].message}`)}
                    </Alert>
                }
              </Grid>
            </Grid>
        ))}

        <Grid container direction="row" className="mb-2">
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <GeneralButton
                name="submit"
                type="submit"
                className="submit_login col-md-2 col-lg-2"
                style={{ width: '-webkit-fill-available' }}
                endIcon={<HowToRegIcon color="inherit" />}
            >
              {props.t('register:Register')}
            </GeneralButton>
          </Grid>
        </Grid>
      </form>
  )
}

export default React.memo(withTranslation(['message', 'register'])(RegistrateFormComponent));
